import { Paper, Stack, Button, Divider, Typography } from "@mui/material"
import SequenzaForm from "./SequenzaForm"
import { Sequenza } from "../../types"
import { useRef } from "react"
import { useTranslation } from "react-i18next"

type SequenzaFormPaperProps = {
  item?: Sequenza
  save: (values: Sequenza) => Promise<void>
  handleClose: () => void
  getCurrentTime: () => number
}

export default function SequenzaFormPaper({ item, save, handleClose, getCurrentTime }: SequenzaFormPaperProps) {
  const buttonRef = useRef<HTMLButtonElement>(null)
  const { t } = useTranslation()

  

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 1 }}>
        {item ? <span>{t("sequenza.cta_modifica")} {item.numero_sequenza}</span> : t("sequenza.cta_aggiungi")}
      </Typography>
      <SequenzaForm item={item} save={save} ref={buttonRef} getCurrentTime={getCurrentTime} />
      <Divider sx={{ my: 2 }} />
      
      <Stack
        direction="row"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 4,
        }}
      >

        
        <Button size="large" onClick={handleClose} variant="text">
          {t("general.annulla")}
        </Button>

        <Button color="primary" size="large" variant="contained" onClick={() => buttonRef.current?.click()}>
          {t("general.salva")}
        </Button>
      </Stack>
    </Paper>
  )
}
